import { type ReactElement, type ReactNode, useState, useEffect } from "react"

export interface PhoneNumberProps {
        value: string;
        onValueChange(value: string): void;
}

export default function PhoneNumberInput(props: PhoneNumberProps): ReactElement {


        const formatPhoneNumber = (value: any) => {
                let val = value;
                val = val.replace(/ /gm, '');
                let num = `${val.substring(0, 3)} ${val.substring(3, 6)} ${val.substring(6, val.length)}`;
                num = num.trim();
                props.onValueChange(num);
        }

        useEffect(() => {
                formatPhoneNumber(props.value);
        }, [])

        return <>
                <input className="w-full px-1 py-1 border rounded-lg" type="text" value={props.value} maxLength={15} onChange={(e) => formatPhoneNumber(e.target.value)} />
        </>
}

